interface GetNumberOfColsParams {
  containerWidth?: number;
  containerPadding?: number;
  colWidth?: number;
  colGap?: number;
}

export const getNumberOfCols = ({ containerWidth = 0, containerPadding = 0, colWidth = 0, colGap = 0 }: GetNumberOfColsParams) => {
  return Math.floor((containerWidth - containerPadding * 2 + colGap) / (colWidth + colGap));
};
